export default __webpack_public_path__ + "static/media/Minicard_7d.1744403b.svg";